import Courses from "./Courses.vue";

export default Courses;
